
        import 'Exclusion.0ef04d7.css-module'
        export default {"Exclusion":"Exclusion_Exclusion_0ef04d7","expanded":"expanded_Exclusion_0ef04d7"}
    